<template>
  <div
    v-if="app"
    class="container detail-container" :class="
    hasNoAccess(app) ? 'no-access' : 
    userHasAccess(app)? 'active-access' :
    hasLastAccess(app) ? 'last-access' : 
    'unknown-access'">
    <div class="row content-container">
      <div class="col-12 back-btn-container">
        <button class="close close-btn" @click="closeDetailView()">
          <font-awesome-icon icon="times"/>
        </button>
        <span class="has-no-access-container" v-if="hasNoAccess(app)">          
          <font-awesome-icon icon="circle"/>
          <p
            v-if="hasLastAccess(app)"
            class="access-text"
          >Last accessed : {{app.access.last_accessed | timestampToDate}}</p>
          <p v-else class="access-text">No access</p>
        </span>
        <span class="has-access-container" v-else-if="userHasAccess(app)">
          <font-awesome-icon icon="circle"/>
          <p
            v-if="hasLastAccess(app)"
            class="access-text"
          >Last accessed : {{app.access.last_accessed | timestampToDate}}</p>
          <p v-else class="access-text">Access</p>
        </span>
        <span class="has-last-access-container" v-else-if="hasLastAccess(app)">
          <font-awesome-icon icon="circle"/>
          <p class="access-text">Last accessed : {{app.access.last_accessed | timestampToDate}}</p>
        </span>
      </div>
      <div class="col-sm-3">
        <div class="icon-container">
          <img
            ref="appImg"
            :src="getAppIcon(app)"
            @error="()=>{this.$refs.appImg.src = placeHolder}"
          >
        </div>
      </div>
      <div class="col-sm-9">
        <h3 class="title-display">{{app.title}}</h3>
        <span class="fav-container">
          <font-awesome-icon class="fav-icon" v-if="app.isFavorite" @click="removeFavorite()" :icon="['fas', 'star']" title="Remove from favorites"/>
          <font-awesome-icon class="fav-icon" v-else @click="addFavorite()" :icon="['far', 'star']" title="Add to favorites"/>
        </span>
        <hr>
        <div class="row">
          <div class="col-sm-12">
            <div class="info-container">
              <strong>Description:</strong>
              <!-- <p>{{app.short_desc || '&nbsp;'}}</p> -->
              <p v-html="sanitizer(app.short_desc) || '&nbsp;'"></p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6">
            <strong>Tag line:</strong>
            <p>{{app.tag_line || '&nbsp;'}}</p>
          </div>
          <div class="col-sm-6">
            <strong>Entitlement: </strong>
            <entitlement-display :app="app"></entitlement-display>            
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="offset-lg-3 col-lg-9">
        <div class="row detail-action-container">
          <div class="col-md-4">
            <root-link :app="app"></root-link>
          </div>
          <div class="col-md-4" v-for="(link, index) in app.links" :key="index">
            <div v-if="link.display_type == CONSTANTS.ROOT_LINK_TYPES.AZURE_ACCESS_LINK">
              <button
                class="btn flat-blue-btn"
                @click="showAccessRequestModal(link)"
                :title="link.help_text | trim"
              >{{link.title}}</button>
            </div>
            <div class="dropdown" v-else-if="link.display_type=='list'">
              <button
                class="btn flat-blue-btn dropdown-toggle"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >{{link.title}}</button>
              <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <div v-for="(item, index) in link.items" :key="index">
                  <router-link
                    v-if="item.url.indexOf('/view-app/') > -1"
                    @click="actionItemClick(item)"
                    class="nav-link"
                    :to="item.url"
                  >{{item.title}}</router-link>
                  <a
                    v-else
                    class="dropdown-item"
                    @click="actionItemClick(item)"
                    :href="item.url"
                    target="_blank"
                  >{{item.title}}</a>
                </div>
              </div>
            </div>
            <div v-else>
              <router-link
                v-if="link.reference.indexOf('/view-app/') > -1"
                class="btn flat-blue-btn"
                @click="actionClick(link)"
                :to="link.reference"
                :title="link.help_text | trim"
                style="padding: 10px;"
              >{{link.title}}</router-link>
              <a
                v-else
                id="detail-button"
                class="btn flat-blue-btn"
                @click="openLink(link)"
                :title="link.help_text | trim"
                :href="link.reference"
                target="_blank"
              >{{link.title}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <access-request-modal
      v-if="displayAccessRequestModal"
      :model="app"
      :linkData="linkData"
      @close="closeAccessRequestModal"
    />
  </div>
</template>

<script>
import Sanitizer from 'sanitize-html'
import api from '@/api'
import { mapGetters, mapActions } from "vuex";
import * as CONSTANTS from "../constants.js";
import util from "@/util";
import AppHandlerMixin from "@/mixins/AppHandlerMixin";
import RootLink from "@/components/RootLink";
import EntitlementDisplay from '@/components/EntitlementDisplay'

export default {
  name: "AppDetail",
  components: { RootLink, 
  EntitlementDisplay },
  mixins: [AppHandlerMixin],
  data: function() {
    return {
      CONSTANTS,
      sanitizer : Sanitizer,
      app: undefined
    };
  },
  watch: {
    $route(to, from) {
      this.updateViewData();
    }
  },
  computed: {
    ...mapGetters(["getApplications", "getPreviousRoute", "getUser"])
  },
  mounted() {
    this.updateViewData();

  },
  methods: {
    ...mapActions(["addAlert"]),
    updateViewData() {
      var routeId = this.$route.params.id;
      this.app = this.getApplications.find(e => e.id === routeId);
      if (!this.app) {
        this.addAlert(
          util.createAlert(
            0,
            CONSTANTS.ERROR_MSGS.APP_NOT_FOUND_WARN,
            CONSTANTS.ALERT_CONTEXT.WARNING
          )
        );
        this.$router.push({ path: "/all" });
      }
    },
    openLink(link) {
      this.actionClick(link)
      //window.open(link.reference, "_blank");
    },
    navigateBack() {
      this.$router.go(-1);
    },
    closeDetailView() {
      // if previous path is a detail view, route to home
      if (this.getPreviousRoute.fullPath.includes("/view-app/")) {
        this.$router.push({ path: "/" });
      } else {
        this.$router.push({ path: this.getPreviousRoute.fullPath });
      }
    },
    actionClick(model) {
      let ref = {};
      ref.action = model.action;
      ref.link = model.reference;
      
      this.trackEvent(`app_id=${this.app.id} title=${this.app.title} ref=${model.reference} type=sub-link`);
      util.postActionClick(this.app, this.getUser.userName, this.$router.currentRoute.path, ref, "sub-link");
    },
    actionItemClick(item) {
      let ref = {};
      ref.action = item.action;
      ref.link = item.url;

      this.trackEvent(`app_id=${this.app.id} title=${this.app.title} ref=${item.url} type=sub-link`);
      util.postActionClick(this.app, this.getUser.userName, this.$router.currentRoute.path, ref, "sub-link");
    },
    async addFavorite() {
      this.app.isFavorite = true

      try {
        let data = {
          appId : this.app.id
        }
        await api.postFavorite(data)
      } catch (err) {
        console.log("Error adding favorite", err)
        this.addAlert(util.createAlert('',CONSTANTS.ERROR_MSGS.FAVORITES_ERROR,CONSTANTS.ALERT_CONTEXT.DANGER));
        this.app.isFavorite = false
      }

    },
    async removeFavorite() {
      this.app.isFavorite = false
      
      try {
        await api.deleteFavorite(this.app.id)
      } catch (err) {
        console.log("Error deleting favorite", err)
        this.addAlert(util.createAlert('',CONSTANTS.ERROR_MSGS.FAVORITES_ERROR,CONSTANTS.ALERT_CONTEXT.DANGER));
        this.app.isFavorite = true
      }

    }
  }
};
</script>
<style scoped>

.title-display {
  display: inline-block;
  margin-bottom: 0;
}
.fav-container {
  margin-left: 20px;
}
.fav-icon {
  cursor: pointer;
  color: var(--secondary-color);
  font-size: 18px;
  margin-bottom: 1px;
}
.has-access-container svg {
  width: 7px;
  float: left;
  color: #7ed321;
  height: 21px;
  margin-top: 2px;
  margin-right: 4px;
}
.has-access-container .access-text {
  font-size: 14px;
  color: #7ed321;
  float: left;
  padding-right: 5px;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 2px;
  margin-right: 15px;
}

.has-last-access-container svg {
  width: 7px;
  float: left;
  color: #0696d7;
  height: 21px;
  margin-right: 4px;
  margin-top: 2px;
}
.has-last-access-container .access-text {
  font-size: 14px;
  color: #0696d7;
  float: left;
  padding-right: 5px;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 2px;
  margin-right: 15px;
}

.has-no-access-container svg {
  width: 7px;
  float: left;
  color: #999999;
  height: 21px;
  margin-right: 4px;
  margin-top: 2px;
}
.has-no-access-container .access-text {
  font-size: 14px;
  color: #999999;
  float: left;
  padding-right: 5px;
  font-weight: bold;
  margin-bottom: 0;
  margin-top: 2px;
  margin-right: 15px;
}
h3 {
  font-weight: bold;
  font-size: 25px;
  color: #575757;
  margin-top: 20px;
  margin-left: 0;
}
.back-btn-container {
  margin-bottom: 15px;
}
.back-btn-container .btn {
  max-width: 120px;
}
.detail-container {
  margin-top: 30px;
  margin-bottom: 30px;
  border-radius: 3px;
  border: 1px #64788d solid;
  
}
.content-container {
  margin: 15px 0px;
}
.tile {
  margin-bottom: 25px;
  padding-right: 8px;
  padding-left: 8px;
}
.icon-container {
  min-height: 100px;
}
.icon-container img {
  position: absolute;
  width: 100px;
  max-height: 100px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.detail-action-container {
  margin-top: 35px;
  margin-bottom: 35px;
}
.dropdown {
  height: 100%;
}

.dropdown-menu {
  width: 100%;
}
.dropdown-item {
  color: #32bcad;
  cursor: pointer;
}
.dropdown-item.active,
.dropdown-item:active {
  color: #fff;
  background-color: #32bcad;
}
.active-access {
  border-top: 7px #7ed321 solid;
}
.last-access {
  border-top: 7px #0696d7 solid;
}
.no-access {
  border-top: 7px #999999 solid;
}
.unknown-access {
  padding-top: 7px;
}
@media (max-width: 767px) {
  .has-access-container .access-text {
    margin-bottom: 10px;
  }
}
</style>
